document.addEventListener('DOMContentLoaded', () => { 
  const drawer = document.getElementById('CustomCartDrawer');
  const closeBtn = document.getElementById('CustomCartDrawerClose');
  const PREMIUM_HANDLE = 'premium-delivery-protection';

  // 👇 your code can contain spaces/% etc; we'll encode it for the URL
  const DISCOUNT_CODE = '25% OFF';
  const DISCOUNT_CODE_ENC = encodeURIComponent(DISCOUNT_CODE); // '25%25%20OFF'

  /* -------------------------
   AUTO APPLY DISCOUNT CODE
-------------------------- */
async function autoApplyDiscount() {
  try {
    // Already applied? stop
    if (localStorage.getItem('discountApplied') === 'true') return;

    const res = await fetch('/cart.js');
    const cart = await res.json();

    // No cart → nothing to do
    if (cart.item_count === 0) return;

    // Check if discount is already active
    const hasCode = (cart.discount_codes || []).some(dc =>
      (dc.code || '').toUpperCase() === DISCOUNT_CODE.toUpperCase() &&
      dc.applied !== false
    );

    if (hasCode) {
      localStorage.setItem('discountApplied', 'true');
      return;
    }

    // Apply discount silently via API (NO REDIRECT)
    await fetch(`/discount/${DISCOUNT_CODE_ENC}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    });

    // Re-check cart for discount
    const updated = await fetch('/cart.js').then(r => r.json());
    const nowHasCode = (updated.discount_codes || []).some(dc =>
      (dc.code || '').toUpperCase() === DISCOUNT_CODE.toUpperCase() &&
      dc.applied !== false
    );

    if (nowHasCode) {
      localStorage.setItem('discountApplied', 'true');
      await loadCartDrawer();
      syncCartBubbles();
    }

  } catch (err) {
    console.error('Error applying discount:', err);
  }
}


  // After page load, if our last attempt didn't result in an applied code, allow retry
  (async function reconcileDiscountFlag() {
    try {
      const flag = localStorage.getItem('discountApplied');
      if (!flag) return;
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const hasCode = (cart.discount_codes || []).some(dc =>
        (dc.code || '').toUpperCase() === DISCOUNT_CODE.toUpperCase() && dc.applied !== false
      );
      localStorage.setItem('discountApplied', hasCode ? 'true' : '');
    } catch {}
  })();

  // Apply discount on load once
  autoApplyDiscount();

  /* -------------------------
     UTILITY HELPERS
  -------------------------- */
  function toCents(v) {
    if (typeof v === 'number') return Math.round(v);
    if (typeof v === 'string') {
      return v.includes('.') ? Math.round(parseFloat(v) * 100) : parseInt(v, 10) || 0;
    }
    return 0;
  }

  // ✅ Detect store currency
  function getCurrency(cart) {
    if (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) {
      return Shopify.currency.active;
    }
    if (cart && cart.currency) return cart.currency;
    return 'USD';
  }

  // ✅ Use Shopify.formatMoney if available, otherwise fallback
  function money(cents, cart = null) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, Shopify.money_format || '${{amount}}');
    }

    const currency = getCurrency(cart);
    const amount = (Math.max(0, cents) / 100).toFixed(2);

    const symbols = {
      USD: '$',
      CAD: 'C$',
      AUD: 'A$',
      GBP: '£',
      EUR: '€',
      NZD: 'NZ$'
    };
    const symbol = symbols[currency] || '';
    return `${symbol}${amount}`;
  }

  // 🏷️ Aggregate discount allocations
  function getCartDiscountBreakdown(cart) {
    const map = new Map();

    (cart.items || []).forEach(item => {
      (item.discount_allocations || []).forEach(da => {
        const title = da?.discount_application?.title || da?.title || 'Discount';
        const amt = toCents(da?.amount);
        map.set(title, (map.get(title) || 0) + amt);
      });
    });

    (cart.cart_level_discount_applications || []).forEach(app => {
      const title = app.title || 'Discount';
      const amt = toCents(app.total_allocated_amount);
      map.set(title, (map.get(title) || 0) + amt);
    });

    return Array.from(map, ([title, amount]) => ({ title, amount }));
  }

  /* -------------------------
     DRAWER TOGGLE + OVERLAY
  -------------------------- */
  function toggleCartDrawer(show) {
    const overlay = document.getElementById('CustomCartDrawerOverlay');
    if (show) {
      drawer.classList.add('active');
      overlay.classList.add('active');
      setTimeout(loadCartDrawer, 150);
    } else {
      drawer.classList.remove('active');
      overlay.classList.remove('active');
    }
  }

  document.getElementById('CustomCartDrawerOverlay')
    .addEventListener('click', () => toggleCartDrawer(false));
  closeBtn?.addEventListener('click', () => toggleCartDrawer(false));

  /* -------------------------
     CART BUBBLE UPDATES
  -------------------------- */
  function updateAllCartBubbles(itemCount) {
    document.querySelectorAll('.site-header__cart-bubble').forEach(bubble => {
      if (itemCount > 0)
        bubble.classList.add('site-header__cart-bubble--visible');
      else
        bubble.classList.remove('site-header__cart-bubble--visible');
    });
  }

  function syncCartBubbles() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => updateAllCartBubbles(cart.item_count))
      .catch(() => {});
  }

  /* -------------------------
     PREMIUM PROTECTION
  -------------------------- */
  async function addPremiumProtection() {
    try {
      const res = await fetch(`/products/${PREMIUM_HANDLE}.js`);
      const product = await res.json();
      const variantId = product.variants[0].id;

      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      const alreadyInCart = cart.items.some(i => i.handle === PREMIUM_HANDLE);
      if (alreadyInCart) return;

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
    } catch (err) {
      console.error('Error adding protection:', err);
    }
  }

  async function removePremiumProtection() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const protectionItem = cart.items.find(i => i.handle === PREMIUM_HANDLE);
      if (!protectionItem) return;

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: protectionItem.key, quantity: 0 })
      });
    } catch (err) {
      console.error('Error removing protection:', err);
    }
  }

  async function enforceProtectionRule({ fromAdd = false } = {}) {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    const hasProtection = cart.items.some(i => i.handle === PREMIUM_HANDLE);
    const visibleItems = cart.items.filter(i => i.handle !== PREMIUM_HANDLE);

    if (visibleItems.length === 0 && hasProtection) {
      await removePremiumProtection();
      return;
    }

    if (fromAdd && visibleItems.length === 1 && !hasProtection) {
      await addPremiumProtection();
      return;
    }
  }

  /* -------------------------
     LOAD CART DRAWER
  -------------------------- */
  async function loadCartDrawer() {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    const drawerItems = document.getElementById('CustomCartDrawerItems');
    const drawerSubtotal = document.getElementById('CustomCartDrawerSubtotal');
    const protectionSection = document.getElementById('PremiumProtectionSection');
    const continueBtn = document.getElementById('CartDrawerContinue');
    if (!drawerItems || !drawerSubtotal) return;

    drawerItems.innerHTML = '';

    const visibleItems = cart.items.filter(i => i.handle !== PREMIUM_HANDLE);

    if (visibleItems.length === 0) {
      drawerItems.innerHTML = '<p>Your cart is empty.</p>';
      drawerSubtotal.innerHTML = `
        <div class="subtotal-line"><span>Subtotal</span><span>${money(0, cart)}</span></div>
        <div class="shipping-line"><span>Shipping</span><span>Free</span></div>
      `;
      updateAllCartBubbles(0);
      if (protectionSection) protectionSection.style.display = 'none';
      return;
    }

    updateAllCartBubbles(cart.item_count);

    visibleItems.forEach(item => {
      const discountArray = item.discount_allocations?.length
        ? item.discount_allocations
        : item.discounts?.length
        ? item.discounts
        : [];

      const itemDiscountLines = discountArray
        .map(d => {
          const title =
            d.discount_application?.title ||
            d.title ||
            d.discount_application?.code ||
            'Discount';
          return `<span class="discount-line">${title}</span>`;
        })
        .join('');

      const hadCompare =
        item.original_line_price && item.original_line_price !== item.line_price;

      drawerItems.innerHTML += `
        <div class="custom-cart-drawer__item" data-key="${item.key}">
          <img src="${item.image}" alt="${item.product_title}" class="custom-cart-drawer__item-image">
          <div class="custom-cart-drawer__item-details">
            <div class="custom-cart-drawer__info">
              <div>
                <p class="custom-cart-drawer__item-title">${item.product_title}</p>
                ${item.variant_title ? `<p class="custom-cart-drawer__item-variant">${item.variant_title}</p>` : ''}
                ${itemDiscountLines}
              </div>
              <div class="custom-cart-drawer__item-price">
                ${hadCompare ? `<span class="compare-at-price">${money(item.original_line_price, cart)}</span>` : ''}
                <span class="discounted-price">${money(item.line_price, cart)}</span>
              </div>
            </div>
            <div class="custom-cart-drawer__qty-control">
              <button class="qty-btn minus" data-key="${item.key}">−</button>
              <span class="qty-number">${item.quantity}</span>
              <button class="qty-btn plus" data-key="${item.key}">+</button>
            </div>
          </div>
        </div>`;
    });

    const discountBreakdown = getCartDiscountBreakdown(cart);
    const discountSummaryHTML = discountBreakdown
      .map(
        d => `
          <div class="discount-summary-line">
            <span>${d.title}</span>
            <span>− ${money(d.amount, cart)}</span>
          </div>`
      )
      .join('');

    const originalSubtotal = toCents(
      cart.original_total_price ?? cart.total_price + toCents(cart.total_discount)
    );
    const finalTotal = toCents(cart.total_price);
    const totalSavings = Math.max(0, originalSubtotal - finalTotal);

    drawerSubtotal.innerHTML = `
      <div class="subtotal-line">
        <span>Subtotal</span>
        <span>${money(originalSubtotal, cart)}</span>
      </div>
      ${discountSummaryHTML}
      <div class="total-line">
        <strong>Total</strong>
        <strong>${money(finalTotal, cart)}</strong>
      </div>
      <div class="shipping-line">
        <span>Shipping</span>
        <span>Free</span>
      </div>
    `;

    attachQtyListeners();
    renderPremiumProtection(cart);
    continueBtn?.addEventListener('click', () => toggleCartDrawer(false));
  }

  /* -------------------------
     QUANTITY BUTTONS
  -------------------------- */
  function attachQtyListeners() {
    document.querySelectorAll('.qty-btn').forEach(btn => {
      btn.addEventListener('click', async e => {
        const key = e.currentTarget.dataset.key;
        const isPlus = e.currentTarget.classList.contains('plus');

        const res = await fetch('/cart.js');
        const cart = await res.json();
        const item = cart.items.find(i => i.key === key);
        if (!item) return;

        const newQty = isPlus ? item.quantity + 1 : item.quantity - 1;

        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty })
        });

        await enforceProtectionRule();
        loadCartDrawer();
        syncCartBubbles();
      });
    });
  }

  /* -------------------------
     PREMIUM PROTECTION UI
  -------------------------- */
  function renderPremiumProtection(cart) {
    const container = document.getElementById('PremiumProtectionSection');
    if (!container) return;

    const hasOtherItems = cart.items.some(i => i.handle !== PREMIUM_HANDLE);
    const hasProtection = cart.items.some(i => i.handle === PREMIUM_HANDLE);

    container.style.display = hasOtherItems ? 'block' : 'none';
    container.innerHTML = `
      <div class="premium-protection">
        <div class="premium-protection__header">
          <span class="premium-protection__title">Premium Package Protection</span>
          <label class="premium-protection__switch">
            <input type="checkbox" id="premiumProtectionToggle" ${hasProtection ? 'checked' : ''}>
            <span class="slider"></span>
          </label>
        </div>
        <p class="premium-protection__text">
          For ${money(725, cart)}, we protect your delivery in the event it is damaged, stolen, or lost during transit.
        </p>
      </div>`;

    const toggle = document.getElementById('premiumProtectionToggle');
    toggle?.addEventListener('change', async e => {
      if (e.target.checked) await addPremiumProtection();
      else await removePremiumProtection();
      loadCartDrawer();
    });
  }

  /* -------------------------
     ADD TO CART INTERCEPT
  -------------------------- */
  document.querySelectorAll('form.product-form').forEach(form => {
    const addBtn = form.querySelector('.product__add-to-cart-button');
    addBtn?.addEventListener('click', async e => {
      e.preventDefault();
      e.stopImmediatePropagation();

      const formData = new FormData(form);
      await fetch('/cart/add.js', { method: 'POST', body: formData });
      await enforceProtectionRule({ fromAdd: true });

      toggleCartDrawer(true);
      syncCartBubbles();
      autoApplyDiscount(); // re-check discount if cart was empty
    }, true);
  });

  /* -------------------------
     HEADER CART CLICK
  -------------------------- */
  document.addEventListener('click', e => {
    const target = e.target.closest('.site-header__cart.ajax-cart__toggle');
    if (!target) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    toggleCartDrawer(true);
  }, true);

  syncCartBubbles();
});
